import React from 'react';
import Layout from '../layouts/layout';
import LunchMenuSVG from '../assets/lunch-one-page.svg';

export default () => (
  <Layout>
    <LunchMenuSVG />
  </Layout>
)
